import { FaGithub } from "react-icons/fa";
import DarkWave from "../Waves/DarkWave";
import "./ProjectLight.css";
// import "./ProjectDark.css"
import smallcase from "../../images/smallcase.png";

function Project1({ id }) {
  return (
    <article id={id} className="project light">
      <h2 className="project__header">Projects</h2>
      <div className="project__main">
        <img
          className="project__image"
          src={smallcase}
          srcset={smallcase}
          sizes="50vw"
          alt="Zoomcar Landing Page"
          width="50%"
          height="auto"
          loading="lazy"
        />
        <div data-aos="fade-left" className="project__right">
          <h3 className="project__title">Stock investing done right</h3>
          <p className="project__description project__body">
          A web  platform to invest in model portfolios of stocks,
           Exchange traded funds, and REITs. Any investor can create
            its own model portfolio or invest in professionally managed.
          </p>
          <p className="project__tech project__body">
            &gt; HTML · CSS · JavaScript · Mongodb · Nodejs · Expressjs
          </p>
          <div className="code_url_div"  >
          <a
            className="project__sourceCode"
            href="https://github.com/sahilgarg29/smallcase.git"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="=Website GitHub Repository"
          >
            <FaGithub className="project__githubLogo" size={25} />
            <h3 className="project__sourceCodeText">Source Code</h3>
          </a>
          <a
            className="project__sourceCode"
            href="https://smallcase-clone.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="=Website GitHub Repository"
          >
            <FaGithub className="project__githubLogo" size={25} />
            <h3 className="project__sourceCodeText">View Project</h3>
          </a>
          </div>

          
        </div>
      </div>
      <DarkWave />
    </article>
  );
}

export default Project1;
